import { render, staticRenderFns } from "./ProvinceCitySelect.vue?vue&type=template&id=45d6cb1c&scoped=true&"
import script from "./ProvinceCitySelect.vue?vue&type=script&lang=js&"
export * from "./ProvinceCitySelect.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceCitySelect.vue?vue&type=style&index=0&id=45d6cb1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6cb1c",
  null
  
)

export default component.exports